import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "foton_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });
  const [searchContext, setSearchContext] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("foton_search_ctx") || "null");
    } catch {
      return null;
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem("foton_search_ctx", JSON.stringify(searchContext));
  }, [searchContext]);

  const has = (id) => items.some((p) => p.id === id);

  const add = (photo) => {
    setItems((prev) => {
      if (prev.find((p) => p.id === photo.id)) return prev;
      return [...prev, photo];
    });
  };

  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));

  const clear = () => setItems([]);

  const total = items.reduce((s, p) => s + (p.price_sek || 0), 0);
  const photographerId = items[0]?.photographer_id || null;

  return (
    <CartContext.Provider
      value={{ items, add, remove, clear, has, total, count: items.length, photographerId, searchContext, setSearchContext }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart outside provider");
  return ctx;
}
